// import "@fontsource/noto-sans-jp/400.css";
// import "@fontsource/noto-sans-jp/500.css";
// import "@fontsource/noto-sans-jp/700.css";
import { Fragment } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { RecoilRoot } from 'recoil';
import AppErrorBoundary from './components/error/AppErrorBoundary';
import AppRoutes from './routes/AppRoutes';

export default function App(): JSX.Element {
  return (
    <RecoilRoot>
      <Fragment>
        <BrowserRouter>
          <AppErrorBoundary>
            <>
              {/* ルート定義 */}
              <AppRoutes />
            </>
          </AppErrorBoundary>
        </BrowserRouter>
      </Fragment>
    </RecoilRoot>
  );
}
